import { render, staticRenderFns } from "./LabelConfigEdit.vue?vue&type=template&id=47b6dafc&scoped=true"
import script from "./LabelConfigEdit.vue?vue&type=script&lang=js"
export * from "./LabelConfigEdit.vue?vue&type=script&lang=js"
import style0 from "./LabelConfigEdit.vue?vue&type=style&index=0&id=47b6dafc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b6dafc",
  null
  
)

export default component.exports